import { render, staticRenderFns } from "./OtherPlatforms.vue?vue&type=template&id=4b04d1c3&scoped=true&"
import script from "./OtherPlatforms.vue?vue&type=script&lang=js&"
export * from "./OtherPlatforms.vue?vue&type=script&lang=js&"
import style0 from "./OtherPlatforms.vue?vue&type=style&index=0&id=4b04d1c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b04d1c3",
  null
  
)

export default component.exports